module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 3-caea75665edbdb148a65f432b45a6239.jpg";